var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeWebGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 3H3.5C3.10218 3 2.72064 3.15804 2.43934 3.43934C2.15804 3.72064 2 4.10218 2 4.5V16.5C2 16.8978 2.15804 17.2794 2.43934 17.5607C2.72064 17.842 3.10218 18 3.5 18H9.5V21H6.5V22.5H18.5V21H15.5V18H21.5C21.8978 18 22.2794 17.842 22.5607 17.5607C22.842 17.2794 23 16.8978 23 16.5V4.5C23 4.10218 22.842 3.72064 22.5607 3.43934C22.2794 3.15804 21.8978 3 21.5 3ZM14 21H11V18H14V21ZM21.5 16.5H3.5V4.5H21.5V16.5Z",
    fill: "#171719"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWebGray);
export default __webpack_public_path__ + "static/media/home-web_gray.4719c64a65f0685d3f5f53cb921e6140.svg";
export { ForwardRef as ReactComponent };